import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { omit } from 'ui-addon-upgrades/utils';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getCorrectedUpgradeData } from '../_core/utils/getCorrectedUpgradeData';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { AssignSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface';
import { getCanViewNewSeats } from '../_core/common/eligibility/getCanViewNewSeats';

const UIAssignSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData
  } = props;
  const correctedUpgradeData = getCorrectedUpgradeData(upgradeData);
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'usageLimitBannerData');
  const [canViewNewSeats, setCanViewNewSeats] = useState();
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    getCanViewNewSeats().then(res => {
      setCanViewNewSeats(res);
    }).catch(() => {
      setCanViewNewSeats(false);
    });
  }, [correctedUpgradeData, usageLimitBannerData, level]);

  const trackClick = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    tracker.track('interaction', Object.assign({
      action: 'clicked assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
  };

  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    "data-reagan-primary-cta": true
  }, propsToPass, {
    href: getPaidUserManagementUrl(canViewNewSeats),
    external: true,
    onClick: trackClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.assignSeatButton"
    })
  }));
};

UIAssignSeatButton.propTypes = AssignSeatButtonPropsInterface;
export default UIAssignSeatButton;